<template>
    <div v-show="visible">
        <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible" 
        v-loading="loading"
        :element-loading-text = "loadingText"
        element-loading-background = "rgba(255, 255,255,0.7)"
        :before-close="dialogClose"  width="480px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                    
                <el-form-item prop="deviceNo" label="设备编号">
                    <el-select v-model="form.deviceNo" clearable placeholder="请选择">
                        <el-option
                            v-for="item in devices"
                            :key="item.deviceNo"
                            :label="item.deviceNo"
                            :value="item.deviceNo">
                            <span style="float: right;font-size: 13px">{{ item.deviceNo }}-{{ item.address }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="visitorUsers" label="被访人名单">
                    <el-button @click="findUser()">{{form.visitorUsersLabel}}</el-button>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
       
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import userTransfer from '../../sys/user/UserTransfer.vue';

    export default {
        data(){
            return{
                visible: false,
                transferVisible:false,
                loading:false,
                loadingText:"",
                props: { checkStrictly: true},
                form:{
                    deptId:"",
                    deviceNo:"",
                    visitorUsers:[],
                    visitorUsersLabel:"请选择"
                },
                rules: {
                    deviceNo: [
                        { required: true, message: '请选择设备编号', trigger: 'blur' }
                    ]
                },
                devices:[]
            }
        },
        created:function () {
        },
        components: {
            userTransfer
        },
        methods:{
            init(deptId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.visitorUsers=[];
                this.form.visitorUsersLabel="请选择";
                this.form.deptId=deptId;
                this.getDevices();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            // 获取设备
            getDevices(){
                let url  = this.listDeviceSelectUrl;
                let data = {
                    deviceTypeStr:'9',
                    commonSign:1,
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                      this.devices = res.data.list; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 绑定人员
            findUser(){
                this.transferVisible=true;
                this.$nextTick(() => {
                    if(this.$util.isNotEmpty(this.form.visitorUsers)){
                        this.$refs['userTransfer'].init(2,this.form.visitorUsers,2,this.form.deptId);
                    }else{
                        this.$refs['userTransfer'].init(2,null,2,this.form.deptId);
                    }
                })
            },
            setUser(keyArr){
                if(keyArr.length == 0){
                    this.form.visitorUsers=keyArr;
                    this.form.visitorUsersLabel="请选择";
                }else{
                  this.form.visitorUsers=keyArr;
                  this.form.visitorUsersLabel=keyArr.length+"人";
                }
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){

                        // 被访人名单不可为空
                        if(this.form.visitorUsers.length ==0 ){
                             this.$commonFn.showTip('请选择被访人名单',3);
                             return;
                        }

                        this.loading=true;
                        this.loadingText="提交中...";

                        let url = this.setVisitorSaveUrl;
                        let data = {
                            deptId:this.form.deptId,
                            deviceNo:this.form.deviceNo,
                            visitorUsers:this.form.visitorUsers.join(),
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                                this.$parent.getData();
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/set/visitor/Add.vue